
import { DealerModel } from './dealer'
import { SchoolModel } from './school'
export enum OrderStatus {
  CLOSED='CLOSED',
  ERROR='ERROR',
  REFUNDING='REFUNDING',
  REFUND='REFUND',
  SUCCESS='SUCCESS',
  TO_BE_PAID = 'TO_BE_PAID',
  PAID='PAID',
}

export const OrdersOrderBy: {
  [key: string]: string;
} = {
  bankType: 'BANK_TYPE',
  className: 'CLASS_NAME',
  createdAt: 'CREATED_AT',
  errCode: 'ERR_CODE',
  errCodeDes: 'ERR_CODE_DES',
  orderNumber: 'ORDER_NUMBER',
  status: 'STATUS',
  timeEnd: 'TIME_END',
  totalPrice: 'TOTAL_AMOUNT',
  tradeType: 'TRADE_TYPE',
  transactionNumber: 'TRANSACTION_NUMBER',
  updatedAt: 'UPDATED_AT',
  year: 'YEAR'
}

export interface OrderModel {
  address: AddressModel;
  addressId: number;
  areaId: number;
  bankType: string;
  buyerMessage: string;
  className: string;
  createdAt: string;
  dealer: DealerModel;
  dealerId: number;
  errCode: string;
  errCodeDes: string;
  id: number;
  items: OrderItemModel[];
  memberId: number;
  memberUniqueId: string;
  orderNumber: string;
  profitSharing: ProfitSharingModel;
  schoolId: number;
  status: OrderStatus;
  timeEnd: string;
  totalPrice: number;
  tradeType: string;
  transactionNumber: string;
  updatedAt: string;
  year: string;
  period: string;

}

 interface OrderItemModel{
  author: string;
  count: number;
  coverImages: string[];
  createdAt: string;
  details: string;
  goodId: number;
  id: number;
  isbn: string;
  press: string;
  price: number;
  publishedDate: string;
  subTitle: string;
  thumb: string;
  title: string;
  updatedAt: string;
}

interface ProfitSharingModel{
  ankType: string;
  createdAt: string;
  errCode: string;
  errCodeDes: string;
  id: number;
  order: OrderModel;
  orderId: number;
  profitSharingNumber: string;
  status: OrderStatus;
  timeEnd: string;
  totalPrice: number;
  tradeType: string;
  transactionNumber: string;
  updatedAt: string;
}

interface AddressModel{
  avaliable: boolean;
  className: string;
  createdAt: string;
  id: number;
  isDefault: boolean;
  phone: string;
  realname: string;
  school: SchoolModel;
  schoolId: number;
  updatedAt: string;
  year: string;
}
